import { Route, type RouteObject } from 'react-router';

export const renderRoutes = (routes: RouteObject[]) => {
  return routes.map((route, index) => {
    const { path, element, children, index: isIndex } = route;

    if (isIndex) {
      return <Route key={index} index element={element} />;
    }

    if (children) {
      return (
        <Route key={index} path={path} element={element}>
          {renderRoutes(children)}
        </Route>
      );
    }

    return <Route key={index} path={path} element={element} />;
  });
};
